function isJSON (str) {
  if (typeof str === 'string') {
    try {
      var obj = evil(str)
      if (typeof obj === 'object' && obj) {
        return obj
      } else {
        return str
      }
    } catch (e) {
      return str
    }
  }
}
function evil (fn) {
  var Fn = Function
  return new Fn('return ' + fn)()
}
export function getChartsData (params) {
  const type = params.type
  return this.fetch({
    url: 'tag/dataOne',
    method: 'post',
    data: params.data
  }).then(res => {
    if (!res) {
      return false
    }
    const data = isJSON(res)
    let chartData = {
      xData: [],
      rows: [],
      legendData: []
    }
    // 单折线图: singleLine
    // 单柱状图: singleBar
    // 多折线图: muchLine
    // 多柱状图: muchBar
    // 饼图: pie
    // 桑基图: sankey
    if (type === 'singleLine' || type === 'singleBar') {
      // 有顺序的
      if (data.xData) {
        chartData.xData = data.xData
        chartData.rows = data.data.sort((b, a) => {
          return b - a
        })
      } else {
        chartData.xData = Object.keys(data)
        chartData.rows = Object.values(data)
        chartData.legendData = Object.keys(data)
      }
      return chartData
    } else if (type === 'muchLine' || type === 'muchBar') {
      chartData.legendData = Object.keys(data)
      // 有顺序的
      const isXData = data[Object.keys(data)[0]].xData
      if (isXData) {
        chartData.xData = isXData
        for (let i in data) {
          chartData.rows.push({
            name: i,
            data: data[i].data
          })
        }
      } else {
        for (let i in data) {
          chartData.rows.push({
            name: i,
            data: Object.values(data[i])
          })
        }
        for (let j in data[chartData.rows[0].name]) {
          chartData.xData.push(j)
        }
      }
      return chartData
    } else if (type === 'pie') {
      return data
    } else if (type === 'sankey') {
      return data
    } else {
      return data
    }
  })
}

export function getVideoResource (params) {
  return this.fetch({
    method: 'get',
    url: params.url,
    responseType: 'blob'
  })
}

export function getMacList (data) {
  return this.fetch({
    method: 'POST',
    url: 'adRegionMac/dataList',
    data
  })
}

export function getDashboardActual (params) {
  return this.fetch({
    method: 'get',
    url: '/api/target/dashboardActual',
    params
  })
}

export function getDashboardTarget (params) {
  return this.fetch({
    method: 'get',
    url: '/api/target/dashboardTarget',
    params
  })
}

export function getQueryService (data) {
  return this.fetch({
    method: 'post',
    url: '/bigdata/star-rocks/api/v1/query-service?token=9a81c1c75dfd47b1bbc6a34b',
    data
  })
}
